import React from 'react'
import Select from '../Select'
import CountryOption from './CountryOption'

const CountriesSelect = (props) => <Select {...props} optionRenderer={CountryOption} />

export default CountriesSelect



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/CountriesSelect/index.js